define('modules/common/controller/FascicoloImpegni',[], function() {
	var Controller = function($scope) {

	};

	return ["$scope", Controller];
});
